// Nom des campagnes auto-suggérées par beeappee — brique unique + testée.
// On horodate « (JJ.MM.AAAA) » pour distinguer les campagnes créées
// automatiquement, SAUF en édition (le nom existe déjà) ou pour une campagne
// créée de zéro (pas de preset.name).

/** Date du jour au format « JJ.MM.AAAA ». */
export function autoDateStr(d = new Date()) {
  return `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}.${d.getFullYear()}`;
}

/**
 * @param {string|null} presetName  nom suggéré (marronnier) ou vide
 * @param {any} editId              défini si on édite une campagne existante
 * @param {Date} date
 * @returns {string}
 */
export function autoCampaignName(presetName, editId = null, date = new Date()) {
  if (!presetName) return '';
  return editId ? presetName : `${presetName} (${autoDateStr(date)})`;
}
